import { FetchState } from '@/types/fetchState';
import { defineStore } from 'pinia';
import { SimTableResponse } from '@/generated/src';
import { generateAPI } from '@/shared/lib';

export const useSimTableStore = defineStore('simTable', {
  state: (): FetchState<SimTableResponse> => ({
    data: null,
    loading: false,
    error: null,
  }),

  getters: {
    /**
     * データが存在するかどうか
     */
    hasData: (state): boolean => state.data !== null,

    /**
     * エラーメッセージ
     */
    errorMessage: (state): string | null => state.error?.message ?? null,

    simTable: (state): SimTableResponse | null => state.data ?? null,
  },

  actions: {
    /**
     * sim_table データを取得
     */
    async fetch(basinId: string, stationId: string, tgttime: string) {
      this.loading = true;
      this.error = null;

      try {
        this.data = await generateAPI().systemApi.simTableApiApiSimTableBasinIdStationIdGet({
          basinId,
          stationId,
          tgttime,
        });
      } catch (error) {
        this.error = error as Error;
        throw error;
      } finally {
        this.loading = false;
      }
    },
    /**
     * データをクリア
     */
    clear() {
      this.data = null;
      this.error = null;
    },
  },
});
